import React, { useEffect, useState } from "react";
import { FaQuoteLeft } from "react-icons/fa";
import image7 from "../Images/image7.jpeg";

/* COUNTER COMPONENT */
const Counter = ({ end }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 1500;
    const stepTime = 20;
    const increment = end / (duration / stepTime);

    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.ceil(start));
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [end]);

  return <>{count}+</>;
};

/* MAIN COMPONENT */
const Rating = () => {
  return (
    <section className="container-fluid py-5">
      <div className="container">
        <div className="row justify-content-center">

          <div className="col-lg-6 col-md-8 col-sm-10 text-center">

{/* TESTIMONIAL */}
<div
  className="p-4 mb-5 mx-auto"
  style={{
    border: "1px solid #e0e0e0",
    borderRadius: "12px",
    backgroundColor: "#fff",
  }}
>
  {/* <FaQuoteLeft size={40} color="#d1d1e0" className="mb-3" /> */}
  <img
  src={image7}
  alt="Your Image"
  width="auto"
  height="170px"
  className="mb-3"
/>


  <h5 className="fw-bold mb-1">SHAILESH KUMAR GUPTA</h5>
  <small className="text-muted d-block mb-3">
    INDUSTRIAL SUPPLY, GUJARAT
  </small>

  <p className="text-muted">
    The supply pump motor performance has been outstanding. It delivers
    consistent pressure, operates smoothly, and requires very low
    maintenance. Since installation, our workflow has become more
    efficient and reliable.
  </p>
</div>


            {/* COUNTERS */}
            <div className="row text-center">
              <div className="col-4">
                <h2 className="fw-bold" style={{ color: "#224b8f" }}>
                  <Counter end={20} />
                </h2>
                <small className="text-muted">
                  YEAR OF EXPERIENCES
                </small>
              </div>

              <div className="col-4">
                <h2 className="fw-bold" style={{ color: "#224b8f" }}>
                  <Counter end={450} />
                </h2>
                <small className="text-muted">
                  ORDERS DELIVERED
                </small>
              </div>

              <div className="col-4">
                <h2 className="fw-bold" style={{ color: "#224b8f" }}>
                  <Counter end={16} />
                </h2>
                <small className="text-muted">
                  HAPPY BUSINESSES CLIENTS
                </small>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default Rating;
